import { render, staticRenderFns } from "./YpoCommunities.vue?vue&type=template&id=42e07112&scoped=true&"
import script from "./YpoCommunities.vue?vue&type=script&lang=js&"
export * from "./YpoCommunities.vue?vue&type=script&lang=js&"
import style0 from "./YpoCommunities.vue?vue&type=style&index=0&id=42e07112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e07112",
  null
  
)

export default component.exports